import {
  IMarketingCampaignEntry,
  IMarketingCampaignEntryLog,
  IStaffer,
  MarketingCampaignEntryCollection,
  MarketingCampaignEntryLogEvent,
} from '@principle-theorem/principle-core/interfaces';
import {
  CollectionReference,
  Firestore,
  INamedDocument,
  IReffable,
  subCollection,
  toTimestamp,
} from '@principle-theorem/shared';

export interface ICreateEntryLogOptions {
  message?: string;
  performedBy?: INamedDocument<IStaffer>;
}

export class MarketingCampaignEntryLog {
  static col(
    entry: IReffable<IMarketingCampaignEntry>
  ): CollectionReference<IMarketingCampaignEntryLog> {
    return subCollection<IMarketingCampaignEntryLog>(
      entry.ref,
      MarketingCampaignEntryCollection.Logs
    );
  }

  static init(
    event: MarketingCampaignEntryLogEvent,
    options: ICreateEntryLogOptions = {}
  ): IMarketingCampaignEntryLog {
    return {
      timestamp: toTimestamp(),
      event,
      deleted: false,
      message: options.message,
      performedBy: options.performedBy,
    };
  }

  static async createEntryLog(
    entry: IReffable<IMarketingCampaignEntry>,
    event: MarketingCampaignEntryLogEvent,
    options: ICreateEntryLogOptions = {}
  ): Promise<void> {
    await Firestore.addDoc(
      MarketingCampaignEntryLog.col(entry),
      MarketingCampaignEntryLog.init(event, options)
    );
  }
}
